import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { Spinner } from 'reactstrap'
import GoogleLogin from 'react-google-login'

import Password from '_components/Password'

import './UserRegisterForm.scss'

const UserRegisterForm = ({
  onClose,
  onSubmitPIN,
  onGoogleSuccess,
  isSubmitting,
}) => {
  const history = useHistory()

  const [pin, setPin] = useState(new Array(4))
  const [pinError, setPinError] = useState('')

  const onPinChanged = (pinEntry, index) => {
    const newPin = [...pin]
    newPin[index] = pinEntry
    setPin(newPin)
  }

  const validatePIN = () => {
    if (pin.some((item) => item === undefined) || pin[0] === undefined) {
      setPinError('Please enter your PIN')
      return false
    }
    setPinError('')
    return true
  }

  const handleSubmit = () => {
    if (!validatePIN()) return
    if (onSubmitPIN) {
      onSubmitPIN(pin)
    }
  }

  return (
    <div className='user-register-form'>
      <div className='user-register-form__header'>
        <h3 className='user-register-form__title'>Finish Signing Up</h3>
        <button
          type='button'
          className='user-register-form__close'
          onClick={onClose}
          aria-label='Close'
        >
          ✕
        </button>
      </div>

      <div className='user-register-form__body'>
        <div className='user-register-form__pin-section'>
          <div className='user-register-form__pin-label'>Enter your PIN</div>
          <Password
            isFirstPin={true}
            pinLength={4}
            onPinChanged={onPinChanged}
            pin={pin}
            isMasked={true}
          />
          {pinError && <small className='user-register-form__error'>{pinError}</small>}
        </div>

        <div className='user-register-form__actions'>
          <button
            type='button'
            className='user-register-form__submit-btn'
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? <Spinner color='light' size='sm' /> : 'Sign Up'}
          </button>
        </div>

        <p className='user-register-form__terms'>
          By signing up to Co-bee, I agree Co-bee&apos;s{' '}
          <a href='/policy' className='user-register-form__link'>Terms of Service</a>
          {' '}and{' '}
          <a href='/policy' className='user-register-form__link'>Privacy Policy</a>
        </p>

        <div className='user-register-form__divider'>
          <span>Or continue with:</span>
        </div>
        <div className='user-register-form__social'>
          <GoogleLogin
            icon={false}
            clientId={process.env.REACT_APP_GOOGLE_APP_ID}
            onSuccess={onGoogleSuccess}
            render={(renderProps) => (
              <button
                type='button'
                className='user-register-form__google-btn'
                onClick={renderProps.onClick}
                disabled={isSubmitting}
              >
                <svg className='user-register-form__google-icon' viewBox='0 0 24 24' width='20' height='20'>
                  <path d='M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z' fill='#4285F4' />
                  <path d='M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z' fill='#34A853' />
                  <path d='M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z' fill='#FBBC05' />
                  <path d='M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z' fill='#EA4335' />
                </svg>
                Google
              </button>
            )}
          />
        </div>

        <div className='user-register-form__footer'>
          Already have a co-bee account?{' '}
          <a
            href='/sign-in'
            className='user-register-form__link'
            onClick={(e) => {
              e.preventDefault()
              history.push('/sign-in')
            }}
          >
            Log in
          </a>
        </div>
      </div>
    </div>
  )
}

UserRegisterForm.propTypes = {
  onClose: PropTypes.func,
  onSubmitPIN: PropTypes.func,
  onGoogleSuccess: PropTypes.func,
  isSubmitting: PropTypes.bool,
}

export default UserRegisterForm
